module.exports = __webpack_public_path__ + "assets/pra-a80d83398e51823f93b82106d2818002.svg";